// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"DJ-z","smallCardRow":"EJ-z","largeCardRow":"FJ-z","productSearchRow":"GJ-z","curatedRow":"HJ-z"};